import { render, staticRenderFns } from "./StudentTransferDialog.vue?vue&type=template&id=96be8f62"
import script from "./StudentTransferDialog.vue?vue&type=script&lang=js"
export * from "./StudentTransferDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentTransferDialog.vue?vue&type=style&index=0&id=96be8f62&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96be8f62')) {
      api.createRecord('96be8f62', component.options)
    } else {
      api.reload('96be8f62', component.options)
    }
    module.hot.accept("./StudentTransferDialog.vue?vue&type=template&id=96be8f62", function () {
      api.rerender('96be8f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentTransferDialog/StudentTransferDialog.vue"
export default component.exports